import { SelectedForMassBookingActionTypes, SelectedForMassBookingState, SELECTED_FOR_MASS_BOOKING_FAILURE, SELECTED_FOR_MASS_BOOKING_REQUEST, SELECTED_FOR_MASS_BOOKING_SUCCESS } from "./types";

const defaultState: SelectedForMassBookingState = {
  isLoading: false,
  errorMessage: ""
};

export default function selectedForMassBookingData(state = defaultState, action: SelectedForMassBookingActionTypes): SelectedForMassBookingState {
  switch (action.type) {
    case SELECTED_FOR_MASS_BOOKING_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SELECTED_FOR_MASS_BOOKING_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case SELECTED_FOR_MASS_BOOKING_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};